export default "/_next/static/images/product--outbound-legacy-f4577fa817dd042a36421797b8b6fc93.svg";